import { Observable } from "rxjs";
import { BRAND_GROUPS_UPDATE, BRAND_GROUPS_UPDATE_COMPLETED } from "constants/action-types";
import siteConfig from "site-config";
import { formatMessage } from "lib/globalize-util";
import { ajax } from "lib/observable";
import "rxjs/add/operator/map";
import { add as snackbarAdd } from "actions/snackbars";

export const updateBrandCustomerUserGroups = (action$, store) => {
    return action$
        .ofType(BRAND_GROUPS_UPDATE)
        .map((action) => action.payload)
        .concatMap(({ exclude_new_groups, groups }) => {
            return ajax({
                method: "POST",
                body: {
                    exclude_new_groups,
                    groups: groups.length > 0 ? groups : [],
                },
                url: `${siteConfig.api}/brand/update/customer-groups`,
            })
                .map(({ response, status }) => {
                    if (response && status === 200) {
                        return { result: response, error: false };
                    } else {
                        return { error: true, result: [] };
                    }
                })
                .flatMap(({ result, error }) => {
                    if (error) {
                        return [
                            store.dispatch(
                                snackbarAdd({ message: formatMessage("Error saving customer and user groups") })
                            ),
                            {
                                payload: [],
                                error: true,
                                type: BRAND_GROUPS_UPDATE_COMPLETED,
                            },
                        ];
                    } else {
                        return [
                            {
                                payload: result,
                                type: BRAND_GROUPS_UPDATE_COMPLETED,
                            },
                            snackbarAdd({ message: formatMessage("Customer and User Groups Updated") }),
                        ];
                    }
                })
                .catch((error) => {
                    let errorMessage = formatMessage("Error saving customer and user groups");
                    if (error.status === 401) {
                        errorMessage = formatMessage("You do not have permission to edit groups");
                    }
                    return Observable.merge(
                        Observable.of({
                            error: true,
                            payload: new Error(errorMessage),
                            type: BRAND_GROUPS_UPDATE_COMPLETED,
                        }),
                        Observable.of(snackbarAdd({ message: errorMessage }))
                    );
                });
        });
};
